export enum LeadCategory {
    All = "All",
    ClientProfile = "Client Profile",
    SetGoal = "Set Goal",
    RiskProfile = "Risk Profile",
    YourAnalysis = "Your Analysis"
}